import React from 'react'
import App from '../components/App'

const IndexPage = () => <App />

export default IndexPage
